<template>
  <div class="content-page">
    <div class="tab-header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/service' }">服务管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{
          goodsForm.goodsId ? "编辑服务" : "新建服务"
        }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="tab-content">
      <el-form
        :model="goodsForm"
        :rules="rules"
        ref="goodsForm"
        label-width="68px"
        class="demo-goodsForm"
        :hide-required-asterisk="true"
      >
        <el-form-item label="服务名称" prop="goodsName">
          <el-input
            v-model="goodsForm.goodsName"
            placeholder="请填写服务名称"
            maxlength="50"
          ></el-input>
        </el-form-item>
        <el-form-item label="服务分类" prop="goodsCategoryId">
          <el-cascader
            v-model="goodsCategoryCascaderValue"
            :options="categoryCascaderOptions"
            :props="categoryCascaderProps"
            clearable
            filterable
            placeholder="请选择"
            @change="handleGoodsCategoryChange"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="服务主图" prop="goodsImage">
          <div>
            <el-upload
              :disabled="uploadDisabled"
              action="/ImageServer/YmUpload_image"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-remove="
                (e) => {
                  handleRemove(e, 'goodsImage');
                }
              "
              :http-request="
                (e) => {
                  handleSuccess(e, 'goodsImage');
                }
              "
              :before-upload="beforeImgUpload"
              :on-exceed="limitTip"
              :file-list="fileList"
              :limit="1"
            >
              <div
                style="width: 148px; height: 148px; position: absolute"
                @click="show_uploadDialog(1, 'goodsImage')"
              ></div>
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt />
            </el-dialog>
          </div>
        </el-form-item>
        <el-form-item label="轮播图" prop="goodsImages">
          <div>
            <el-upload
              :disabled="uploadDisabled"
              action="/ImageServer/YmUpload_image"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-remove="
                (e) => {
                  handleRemove(e, 'goodsImages');
                }
              "
              :http-request="
                (e) => {
                  handleSuccess(e, 'goodsImages');
                }
              "
              :before-upload="beforeImgUpload"
              :file-list="goodsImages"
              :before-remove="beforeRemove"
            >
              <div
                style="width: 148px; height: 148px; position: absolute"
                @click="show_uploadDialog(999, 'goodsImages')"
              ></div>
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt />
            </el-dialog>
          </div>
        </el-form-item>
        <el-form-item label="服务描述" maxlength="100">
          <el-input
            type="textarea"
            placeholder="请填写服务描述"
            v-model="goodsForm.goodsDescription"
          ></el-input>
        </el-form-item>
        <el-form-item label="服务多图" prop="goodsDescriptionImages">
          <div>
            <el-upload
              :disabled="uploadDisabled"
              action="/ImageServer/YmUpload_image"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-remove="
                (e) => {
                  handleRemove(e, 'goodsDescriptionImages');
                }
              "
              :http-request="
                (e) => {
                  handleSuccess(e, 'goodsDescriptionImages');
                }
              "
              :before-upload="beforeImgUpload"
              :file-list="goodsDescriptionImages1"
              :before-remove="beforeRemove"
            >
              <div
                style="width: 148px; height: 148px; position: absolute"
                @click="show_uploadDialog(999, 'goodsDescriptionImages')"
              ></div>
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt />
            </el-dialog>
          </div>
        </el-form-item>
        <el-form-item label="商品规格" prop="products">
          <div class="custom-form">
            <div class="form-header">
              <div class="fixed-width" v-show="isAddGoodsSpec">商品规格</div>
              <div class="fixed-width">价格</div>
              <div class="fixed-width">会员价</div>
              <div class="fixed-width" v-show="isAddGoodsSpec">条码</div>
            </div>
            <div class="form-content">
              <div class="item" v-for="(item, index) in goodsForm.products" :key="index">
                <div class="fixed-width" v-show="isAddGoodsSpec">
                  <el-input
                    placeholder="如：大份"
                    v-model="item.valueContent"
                    size="small"
                    clearable
                  ></el-input>
                </div>
                <div class="fixed-width">
                  <el-input
                    placeholder="填写价格"
                    v-model="item.retailPrice"
                    size="small"
                    @input.native="numberInputChange"
                    @blur="numberInputBlur"
                    clearable
                    type="number"
                    min="1"
                  ></el-input>
                </div>
                <div class="fixed-width">
                  <el-input
                    placeholder="填写会员价格"
                    v-model="item.memberPrice"
                    size="small"
                    @input.native="numberInputChange"
                    @blur="numberInputBlur"
                    clearable
                    type="number"
                    min="1"
                  ></el-input>
                </div>
                <div class="fixed-width" v-show="isAddGoodsSpec">
                  <el-input
                    placeholder="请填写条形码"
                    v-model="item.barCode"
                    size="small"
                    clearable
                  ></el-input>
                </div>
                <div class="indefinite-width">
                  <el-button
                    type="text"
                    v-if="isAddGoodsSpec"
                    @click="delGoodsSpec(index)"
                    >删除</el-button
                  >
                </div>
              </div>
            </div>
            <el-button type="primary" size="small" @click="addGoodsSpec"
              >添加规格</el-button
            >
          </div>
        </el-form-item>
        <el-form-item label="商品属性" prop="freeSpecs" v-if="isAddGoodsSpec">
          <div class="custom-form">
            <div class="form-header">
              <div class="fixed-width">属性名称</div>
              <div class="indefinite-width">属性值</div>
            </div>
            <div class="form-content">
              <div class="item" v-for="(item, index) in goodsForm.freeSpecs" :key="index">
                <div class="fixed-width">
                  <el-input
                    placeholder="如：大份"
                    v-model="item.name"
                    size="small"
                    clearable
                  ></el-input>
                </div>
                <div class="indefinite-width">
                  <el-tag
                    :key="tagindex"
                    v-for="(tag, tagindex) in item.value"
                    closable
                    :disable-transitions="false"
                    @close="handleClose(tag, index)"
                    >{{ tag }}</el-tag
                  >
                  <el-input
                    class="input-new-tag"
                    v-if="item.attrValueInputVisible"
                    v-model="item.attrValueInputValue"
                    :ref="`saveTagInput${index}`"
                    size="small"
                    @keyup.enter.native="handleAttrValueInputConfirm(index)"
                    @blur="handleAttrValueInputConfirm(index)"
                  ></el-input>
                  <el-button
                    v-else
                    class="button-new-tag"
                    size="small"
                    @click="showAttrValueInput(index)"
                    >+ 添加</el-button
                  >
                  <el-button
                    type="text"
                    v-if="goodsForm.freeSpecs.length > 1"
                    @click="delGoodsAttr(index)"
                    >删除</el-button
                  >
                </div>
              </div>
            </div>
            <el-button type="primary" size="small" @click="addGoodsAttr"
              >添加属性</el-button
            >
          </div>
        </el-form-item>
        <!-- <el-form-item label="售价" prop="isRequired">
          <el-input
            placeholder="请填写售价"
            type="number"
            v-model="goodsForm.retailPrice"
          >
            <template slot="prepend"
              >￥</template
            ></el-input
          >
        </el-form-item> -->
        <el-form-item label="划线价">
          <el-input
            placeholder="请填写划线价"
            v-model="goodsForm.scribePrice"
            @input.native="inputChangeLimitFloat($event)"
          ></el-input>
        </el-form-item>
        <el-form-item label="服务时长">
          <el-input
            placeholder="请填写服务时长"
            v-model="goodsForm.serviceTime"
            @input.native="inputChange($event)"
          >
            <template slot="append">分钟</template></el-input
          >
        </el-form-item>
        <el-form-item label="预约数">
          <el-input
            placeholder="请填写预约数"
            v-model="goodsForm.appointmentNum"
            @input.native="inputChange($event)"
          ></el-input>
        </el-form-item>
        <el-form-item label="线上预约">
          <el-radio-group v-model="goodsForm.isAppointmentNeedPay">
            <el-radio :label="2">无需支付</el-radio>
            <el-radio :label="1">需支付</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="网店展示">
          <el-radio-group v-model="goodsForm.isShowInOnlineStore">
            <el-radio :label="1">展示</el-radio>
            <el-radio :label="2">不展示</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="submitForm('goodsForm')"
            :loading="isSubmit"
            >{{ goodsForm.goodsId ? "提交编辑" : "立即创建" }}</el-button
          >
          <el-button @click="resetForm('goodsForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <uploadImgComponent
      :isshow_uploadDialog="isshow_uploadDialog"
      @onClose="close_uploadDialog"
      @getChoose_ImgUrl="getChoose_ImgUrl"
      ref="childRef"
      :ImgLimits="ImgLimits"
      :uploadName="uploadName"
    ></uploadImgComponent>
  </div>
</template>

<script>
import {
  uploadImg,
  getEdcShopGoodsCategorys,
  updateGoods,
  getGoodsAllInfo,
  getDeliverySettingListFree,
} from "@/api";
import { formatGoodsCategoryListForUI } from "@/utils/goodsCategory";
import {
  getCategoryIdFromCascader,
  loadSecondaryCategoryForCascader,
  toCategoryCascaderOptions,
} from "@/utils/secondaryCategory";
import uploadImgComponent from "@/components/uploadImg";
import { mapState } from "vuex";
export default {
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      fileList: [],
      goodsImages: [],
      goodsDescriptionImages1: [],
      goodsForm: {
        goodsNatureType: 2,
        goodsId: "",
        goodsName: "",
        goodsCategoryId: "",
        goodsDescription: "",
        goodsBarCode: "",
        goodsImage: "",
        goodsImages: "",
        goodsDescriptionImages: "",
        scribePrice: 0,
        isAppointmentNeedPay: 2,
        isShowInOnlineStore: 1,
        serviceTime: 10,
        appointmentNum: 1,
        retailPrice: 0,
        shipPrice: 0,
        deliverySettingId: 0,
        unit: "",
        baseSales: 0,
        isRequired: 0,
        isPromote: 0,
        refundNoAuth: 0,
        isOversold: 0,
        tags: "",
        goodsLabel: [],
        groupIds: [],
        products: [
          {
            productId: "",
            retailPrice: "0.00",
            foodBoxPrice: "0.00",
            memberPrice: "0.00",
            barCode: "",
            stockType: "custom",
            stockCount: 1000,
            valueContent: "",
          },
        ],
        freeSpecs: [
          {
            name: "",
            value: [],
            specValueList: [],
            attrValueInputVisible: false,
            attrValueInputValue: "",
          },
        ],
      },
      rules: {
        goodsImage: [
          {
            required: true,
            message: "请至少上传一张图片",
            trigger: "blur",
          },
        ],
        goodsImages: [
          {
            required: true,
            message: "请至少上传一张图片",
            trigger: "blur",
          },
        ],
        goodsDescriptionImages: [
          {
            required: true,
            message: "请至少上传一张图片",
            trigger: "blur",
          },
        ],
        retailPrice: [
          {
            required: true,
            message: "请填写售价",
            trigger: "blur",
          },
        ],
        scribePrice: [
          {
            required: true,
            message: "请填写划线价",
            trigger: "blur",
          },
        ],
        serviceTime: [
          {
            required: true,
            message: "请填写服务时长",
            trigger: "blur",
          },
        ],
        goodsName: [
          {
            required: true,
            message: "请填写服务名称",
            trigger: "blur",
          },
        ],
        appointmentNum: [
          {
            required: true,
            message: "请填写预约数",
            trigger: "blur",
          },
        ],
        // goodsDescription: [
        //     {
        //         required: true,
        //         message: "请填写服务描述",
        //         trigger: "blur"
        //     }
        // ],
        unit: [
          {
            required: true,
            message: "请填写服务单位",
            trigger: "blur",
          },
        ],
      },
      classifyOptions: [],
      classifyOptionsNoGroup: [],
      categoryCascaderOptions: [],
      goodsCategoryCascaderValue: [],
      groupOptions: [],
      isAddGoodsSpec: false,
      isSubmit: false,
      isshow_uploadDialog: false,
      uploadDisabled: false,
      deliverySettingList: [],
      uploadName: "",
      ImgLimits: 0,
    };
  },
  components: {
    uploadImgComponent,
  },
  computed: {
    ...mapState({
      shopInfo: (state) => state.shopInfo,
    }),
    categoryCascaderProps() {
      return {
        checkStrictly: true,
        emitPath: true,
        lazy: true,
        lazyLoad: this.loadCategoryCascader,
      };
    },
  },
  mounted() {
    // if (this.$route.query.goodsCategoryId) {
    //   this.goodsForm.goodsCategoryId = this.$route.query.goodsCategoryId;
    // }
    this.getPageData();
  },
  methods: {
    getDeliverySettingListFree() {
      getDeliverySettingListFree().then((res) => {
        if (res.code == 1) {
          this.deliverySettingList = res.data;
        }
      });
    },
    show_uploadDialog(val, name) {
      this.ImgLimits = val;
      this.uploadName = name;
      this.uploadDisabled = true;
      this.$refs.childRef.rSelect = [];
      this.isshow_uploadDialog = true;
    },
    getChoose_ImgUrl(arr, name) {
      console.log(arr, name);
      this.isshow_uploadDialog = false;
      this.uploadDisabled = false;
      if (arr.length > 0) {
        arr.forEach((item) => {
          if (name == "goodsImages") {
            // console.log(this.goodsForm.goodsImages, "this.goodsForm.goodsImages");
            if (this.goodsForm.goodsImages.length) {
              this.goodsForm.goodsImages += `,${item.image}`;
            } else {
              this.goodsForm.goodsImages = item.image;
            }
            // console.log(this.goodsImages, "this.goodsImages")
            this.goodsImages.push({ name: "", url: item.image });
            // let goodsImages1 = this.goodsForm.goodsImages.split(",");
            // this.goodsImages = []
            // goodsImages1.forEach(item => {
            //   this.goodsImages.push({ name: "", url: item });
            // })
            return;
          }
          if (name == "goodsDescriptionImages") {
            if (this.goodsForm.goodsDescriptionImages.length) {
              this.goodsForm.goodsDescriptionImages += `,${item.image}`;
            } else {
              this.goodsForm.goodsDescriptionImages = item.image;
            }
            // let goodsImages2 = this.goodsForm.goodsDescriptionImages.split(",");
            // this.goodsDescriptionImages1 = []
            // goodsImages2.forEach(item => {
            //   this.goodsDescriptionImages1.push({ name: "", url: item });
            // })
            this.goodsDescriptionImages1.push({ name: "", url: item.image });
            return;
          }
          this.goodsForm.goodsImage = item.image;
          this.fileList = [{ url: this.goodsForm.goodsImage }];
          this.$refs["goodsForm"].validate();
        });
      }
    },
    close_uploadDialog() {
      this.isshow_uploadDialog = false;
      this.uploadDisabled = false;
    },
    async getPageData() {
      await getEdcShopGoodsCategorys({
        categoryNatureType: 2,
        row: 1000,
      }).then((res) => {
        if (res.code == 1) {
          res.data = formatGoodsCategoryListForUI(res.data);
          this.classifyOptions = res.data;
          res.data.forEach((val) => {
            if (val.categoryType == 2) {
              this.groupOptions.push(val);
            } else {
              this.classifyOptionsNoGroup.push(val);
            }
          });
          this.categoryCascaderOptions = toCategoryCascaderOptions(
            this.classifyOptionsNoGroup,
            {
              includeAll: false,
            }
          );
          let goodsCategoryId =
            this.$route.query.goodsCategoryId &&
            this.$route.query.goodsCategoryId != "hot"
              ? this.$route.query.goodsCategoryId
              : this.classifyOptionsNoGroup[0].goodsCategoryId;
          this.goodsForm.goodsCategoryId = Number(goodsCategoryId);
          this.goodsCategoryCascaderValue = [this.goodsForm.goodsCategoryId];
          this.menuSel = Number(goodsCategoryId);
        }
      });
      if (this.$route.query.goodsId) {
        this.goodsForm.goodsId = this.$route.query.goodsId;
        this.getGoodsAllInfo();
      }
      this.getDeliverySettingListFree();
    },
    getGoodsAllInfo() {
      getGoodsAllInfo({
        goodsId: this.goodsForm.goodsId,
      }).then((res) => {
        if (res.code == 1) {
          let goodsForm = {
            goodsId: res.data.good.goodsId,
            goodsName: res.data.good.goodsName,
            goodsCategoryId: res.data.good.goodsCategoryId,
            goodsDescription: res.data.good.goodsDescription,
            goodsBarCode: res.data.good.goodsBarCode,
            goodsImage: res.data.good.goodsImage,
            goodsImages: res.data.good.goodsImages || "",
            goodsDescriptionImages: res.data.good.goodsDescriptionImages || "",
            scribePrice: res.data.good.scribePrice,
            isAppointmentNeedPay: res.data.good.isAppointmentNeedPay,
            isShowInOnlineStore: res.data.good.isShowInOnlineStore,
            serviceTime: res.data.good.serviceTime,
            retailPrice: res.data.good.retailPrice,
            appointmentNum: res.data.good.appointmentNum,
            shipPrice: res.data.good.shipPrice,
            deliverySettingId: res.data.good.deliverySettingId || 0,
            unit: res.data.good.unit,
            baseSales: res.data.good.baseSales || 0,
            isRequired: res.data.good.isRequired,
            isPromote: res.data.good.isPromote,
            refundNoAuth: res.data.good.refundNoAuth || 0,
            tags: res.data.good.tags,
            goodsLabel: res.data.good.tags ? res.data.good.tags.split(",") : [],
            groupIds: res.data.good.groupIds ? [res.data.good.groupIds] : [],
            products: [],
            freeSpecs: [],
          };
          if (res.data.freeSpecs && res.data.freeSpecs.length) {
            res.data.freeSpecs.forEach((val) => {
              let data = {
                name: val.name,
                value: [],
                specValueList: val.specValueList,
                attrValueInputVisible: false,
                attrValueInputValue: "",
              };
              if (val.specValueList.length) {
                val.specValueList.forEach((subval) => {
                  data.value.push(subval.value);
                });
              }
              goodsForm.freeSpecs.push(data);
            });
          } else {
            goodsForm.freeSpecs = [
              {
                name: "",
                value: [],
                specValueList: [],
                attrValueInputVisible: false,
                attrValueInputValue: "",
              },
            ];
          }
          if (res.data.products && res.data.products.length) {
            this.isAddGoodsSpec = true;
            res.data.products.forEach((val) => {
              let data = {
                goodsId: val.goodsId,
                productId: val.productId,
                retailPrice: val.retailPrice,
                foodBoxPrice: val.foodBoxPrice,
                memberPrice: val.memberPrice,
                barCode: val.barCode,
                stockType: "custom",
                stockCount: val.stockCount,
                valueContent: val.valueContent,
              };
              goodsForm.products.push(data);
            });
          } else {
            goodsForm.products = [
              {
                goodsId: res.data.good.goodsId,
                productId: "",
                retailPrice: res.data.good.retailPrice,
                foodBoxPrice: res.data.good.foodBoxPrice,
                memberPrice: res.data.good.memberPrice,
                barCode: res.data.good.barCode,
                stockType: "custom",
                stockCount: res.data.good.totalStockCount,
                valueContent: "",
              },
            ];
          }
          let goodsImages = goodsForm.goodsImages ? goodsForm.goodsImages.split(",") : [];
          if (goodsImages.length && goodsImages[0].length) {
            this.goodsImages = [];
            goodsImages.forEach((val) => {
              this.goodsImages.push({
                name: val,
                url: val,
              });
            });
          }
          let goodsDescriptionImages = goodsForm.goodsDescriptionImages
            ? goodsForm.goodsDescriptionImages.split(",")
            : [];
          if (goodsDescriptionImages.length && goodsDescriptionImages[0].length) {
            this.goodsDescriptionImages1 = [];
            goodsDescriptionImages.forEach((val) => {
              this.goodsDescriptionImages1.push({
                name: val,
                url: val,
              });
            });
          }
          if (res.data.good.goodsImage) {
            this.fileList = [{ url: res.data.good.goodsImage }];
          } else {
            this.fileList = [];
          }
          this.goodsForm = goodsForm;
          this.goodsCategoryCascaderValue = this.goodsForm.goodsCategoryId
            ? [this.goodsForm.goodsCategoryId]
            : [];
        }
      });
    },
    handleRemove(file, name) {
      console.log(file, name);
      if (name == "goodsImages") {
        let goodsImages = this.goodsForm.goodsImages.split(",");
        let goodsImages1 = this.goodsForm.goodsImages.split(",");
        // console.log(goodsImages.length, goodsImages, "删除前的goodsImages");
        goodsImages.splice(goodsImages.indexOf(file.url), 1);
        // console.log(goodsImages, "删除后的goodsImages");
        this.goodsForm.goodsImages = "";
        this.goodsForm.goodsImages = goodsImages.join(",");
        // console.log(goodsImages, "goodsImages")
        // console.log(this.goodsForm.goodsImages, "this.goodsForm.goodsImages")
        // console.log(this.goodsImages, "删除前的this.goodsImages")
        this.goodsImages.splice(goodsImages1.indexOf(file.url), 1);
        // console.log(this.goodsImages, "删除后的this.goodsImages")
      } else if (name == "goodsDescriptionImages") {
        // console.log(11111);
        let goodsDescriptionImages = this.goodsForm.goodsDescriptionImages.split(",");
        let goodsDescriptionImages1 = this.goodsForm.goodsDescriptionImages.split(",");
        // console.log(goodsDescriptionImages.length, "goodsDescriptionImages.length");
        goodsDescriptionImages.splice(goodsDescriptionImages.indexOf(file.name), 1);
        // console.log(file.name, "file.name");
        this.goodsForm.goodsDescriptionImages = goodsDescriptionImages.join(",");
        this.goodsDescriptionImages1.splice(goodsDescriptionImages1.indexOf(file.url), 1);
      } else {
        this.goodsForm[name] = "";
      }
    },
    limitTip(files, fileList) {
      console.log(file, "file", fileList, "fileList");
      this.$notify({
        title: "警告",
        message: "只能上传一张图片，请删除图片后再上传",
        type: "warning",
        duration: 6000,
      });
    },
    beforeRemove(file, fileList) {},
    beforeImgUpload(file) {
      const isLt3M = file.size / 1024 / 1024 < 3;
      if (!isLt3M) {
        this.$notify.error("上传图片大小不能超过 3MB!");
      }
      return isLt3M;
    },
    handleSuccess(item, name) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", item.file);
      imgUploadForm.append("fileContentType", item.file.type);
      imgUploadForm.append("fileFileName", item.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);
      uploadImg(imgUploadForm).then((res) => {
        console.log(res);
        if (res.code == 1) {
          if (name == "goodsImages" || name == "goodsDescriptionImages") {
            if (this.goodsForm[name].length) {
              this.goodsForm[name] += `,${res.data.url}`;
            } else {
              this.goodsForm[name] = res.data.url;
            }
            return;
          }
          this.goodsForm[name] = res.data.url;
        }
      });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    loadCategoryCascader(node, resolve) {
      loadSecondaryCategoryForCascader(node, resolve, 1000, {
        categoryNatureType: 2,
      });
    },
    handleGoodsCategoryChange(value) {
      this.goodsForm.goodsCategoryId = getCategoryIdFromCascader(value);
    },
    submitForm(formName) {
      console.log(this.goodsForm, "提交编辑");
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.goodsForm));
          params.tags = params.goodsLabel.join(",");
          params.freeSpecs = [];
          params.groupIds = params.groupIds[0];
          let isNoneValueFreeSpecs = false;
          this.goodsForm.freeSpecs.forEach((val, index) => {
            if (val.name && val.value.length) {
              params.freeSpecs[index] = val;
              params.freeSpecs[index].specValueList = [];
              val.value.forEach((subval) => {
                params.freeSpecs[index].specValueList.push({
                  value: subval,
                });
              });
            } else {
              if (val.name) {
                isNoneValueFreeSpecs = true;
              }
              params.freeSpecs.splice(index, 1);
            }
          });
          if (isNoneValueFreeSpecs) {
            this.$notify({
              title: "提示",
              message: "服务属性值不能为空",
              type: "error",
              duration: 2000,
            });
            return;
          }
          params.freeSpecs = JSON.stringify(params.freeSpecs);
          params.totalStockCount = 9e6;
          params.products = [];
          this.isSubmit = true;
          let priceIsZero = false;
          this.goodsForm.products.forEach((val, index) => {
            if (!val.retailPrice) {
              priceIsZero = true;
            }
            if (val.valueContent) {
              params.products.push({
                goodsId: this.goodsForm.goodsId,
                productId: val.productId ? val.productId : "",
                retailPrice: val.retailPrice,
                foodBoxPrice: val.foodBoxPrice || 0,
                memberPrice: val.memberPrice,
                barCode: val.barCode,
                costPrice: 0,
                stockType: "custom",
                stockCount: val.stockCount,
                valueContent: val.valueContent,
              });
              params.totalStockCount += Number(val.stockCount);
            } else {
              if (this.goodsForm.products.length > 1) {
                params.products.splice(index, 1);
              } else {
                params.totalStockCount = val.stockCount;
              }
            }
          });
          if (priceIsZero) {
            return this.$notify.error("价格不能为0");
          }
          params.retailPrice = this.goodsForm.products[0].retailPrice;
          // params.foodBoxPrice = this.goodsForm.products[0].foodBoxPrice || 0;
          params.memberPrice = this.goodsForm.products[0].memberPrice;
          // params.costPrice = this.goodsForm.products[0].costPrice;
          params.products = JSON.stringify(params.products);
          updateGoods(params).then((res) => {
            if (res.code == 1) {
              this.$notify({
                title: "提示",
                message: this.goodsForm.goodsId ? "编辑成功" : "创建成功",
                type: "success",
                duration: 3000,
              });
              // this.$router.go(-1);
              this.$router.push({
                path: "/service",
                query: {
                  pageNo: this.$route.query.pageNo,
                  menuSel: this.$route.query.menuSel,
                },
              });
            } else {
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "error",
                duration: 2000,
              });
            }
            this.isSubmit = false;
          });
        } else {
          this.$notify({
            title: "提示",
            message: "请完善提交内容",
            type: "error",
            duration: 2000,
          });
          return false;
        }
      });
    },
    resetForm(formName) {
      this.fileList = [];

      if (this.$route.query.goodsId) {
        this.goodsForm.goodsId = this.$route.query.goodsId;
        this.getGoodsAllInfo();
      } else {
        this.goodsForm = {
          goodsNatureType: 2,
          goodsId: this.goodsForm.goodsId ? this.goodsForm.goodsId : "",
          goodsName: "",
          goodsCategoryId: this.goodsForm.goodsCategoryId,
          goodsDescription: "",
          goodsBarCode: "",
          goodsImage: "",
          goodsImages: "",
          scribePrice: 0,
          isAppointmentNeedPay: 2,
          isShowInOnlineStore: 1,
          serviceTime: 10,
          appointmentNum: 1,
          retailPrice: 0,
          shipPrice: 0,
          deliverySettingId: 0,
          unit: "",
          baseSales: 0,
          isRequired: 0,
          isPromote: 0,
          refundNoAuth: 0,
          tags: "",
          goodsLabel: [],
          products: [
            {
              productId: "",
              retailPrice: "0.00",
              foodBoxPrice: "0.00",
              memberPrice: "0.00",
              barCode: "",
              stockType: "custom",
              stockCount: 1000,
              valueContent: "",
            },
          ],
          freeSpecs: [
            {
              name: "",
              value: [],
              specValueList: [],
              attrValueInputVisible: false,
              attrValueInputValue: "",
            },
          ],
        };
        this.fileList = [];
        this.goodsImages = [];
        this.goodsDescriptionImages1 = [];
      }
      this.$refs.goodsForm.resetFields();
    },
    addGoodsSpec() {
      if (!this.isAddGoodsSpec) {
        this.isAddGoodsSpec = true;
      } else {
        this.goodsForm.products.push({
          productId: "",
          retailPrice: "0.00",
          foodBoxPrice: "0.00",
          memberPrice: "0.00",
          barCode: "",
          stockType: "custom",
          stockCount: 1000,
          valueContent: "",
        });
      }
    },
    delGoodsSpec(index) {
      if (this.goodsForm.products.length == 1) {
        this.isAddGoodsSpec = false;
        this.goodsForm.products[0].productId = "";
        this.goodsForm.products[0].valueContent = "";
      } else {
        this.goodsForm.products.splice(index, 1);
      }
    },
    addGoodsAttr() {
      this.goodsForm.freeSpecs.push({
        name: "",
        value: [],
        specValueList: [],
        attrValueInputVisible: false,
        attrValueInputValue: "",
      });
    },
    delGoodsAttr(index) {
      this.goodsForm.freeSpecs.splice(index, 1);
    },
    handleClose(tag, index) {
      this.goodsForm.freeSpecs[index].value.splice(
        this.goodsForm.freeSpecs[index].value.indexOf(tag),
        1
      );
    },

    showAttrValueInput(index) {
      this.goodsForm.freeSpecs[index].attrValueInputVisible = true;
      this.$nextTick((_) => {
        this.$refs[`saveTagInput${index}`][0].focus();
      });
    },
    handleAttrValueInputConfirm(index) {
      let attrValueInputValue = this.goodsForm.freeSpecs[index].attrValueInputValue;
      if (attrValueInputValue) {
        this.goodsForm.freeSpecs[index].value.push(attrValueInputValue);
      }
      this.goodsForm.freeSpecs[index].attrValueInputVisible = false;
      this.goodsForm.freeSpecs[index].attrValueInputValue = "";
    },
    inputChangeLimitFloat(e) {
      e.target.value = e.target.value.replace(/[^\d.]/g, "");
      if (!!~e.target.value.indexOf("-")) {
        let stringArray = e.target.value.split("");
        stringArray.splice(e.target.value.indexOf("-"), 1);
        e.target.value = stringArray.join("");
        return;
      }
      if (!!~e.target.value.indexOf(".")) {
        if (e.target.value.split(".").length > 2) {
          e.target.value = e.target.value.slice(0, e.target.value.length - 1);
          return;
        }
        if (e.target.value.split(".")[1].length >= 2) {
          e.target.value = Number(e.target.value).toFixed(2);
        }
      }
    },
    inputChange(e) {
      e.target.value = e.target.value.replace(/[^\d.]/g, "");
      e.target.value = Number(e.target.value);
    },
    numberInputChange(e) {
      if (~e.target.value.indexOf(".") && e.target.value.split(".")[1].length >= 2) {
        e.target.value = Number(e.target.value).toFixed(2);
      }
    },
    numberInputBlur(e) {
      if (e.target.value.indexOf(".") == -1) {
        e.target.value = Number(e.target.value).toFixed(1);
      }
    },
    copyGoodsUrl() {
      var copyText = document.querySelector(`.goodsUrl`);
      copyText.select();
      document.execCommand("copy");
      this.$notify({
        title: "提示",
        message: "复制成功",
        type: "success",
        duration: 1000,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .tab-header {
    padding: 12px 20px;
  }
  .tab-content {
    padding: 40px 48px;
  }
  .custom-form {
    width: 1080px;
    background: #f8f8f8;
    font-size: 14px;
    color: #606266;
    padding: 12px 0 20px 20px;
    box-sizing: border-box;
    .form-header,
    .form-content > .item {
      display: flex;
      & > div {
        margin-right: 20px;
      }
      .fixed-width {
        width: 124px;
        .tips {
          font-size: 12px;
          color: red;
          white-space: nowrap;
        }
        .el-input {
          width: 140px;
        }
      }
      .indefinite-width {
        .el-input {
          width: 100px;
          margin: 0 16px 0 10px;
        }
        .el-tag {
          margin-right: 10px;
        }
        .el-button--text {
          margin-left: 10px;
        }
      }
    }
    & > .el-button {
      margin-top: 18px;
    }
  }
  .el-form-item__content {
    .el-input,
    .el-textarea {
      width: 380px;
    }
  }
  .el-radio {
    margin-right: 20px;
    &:last-child {
      margin-right: 0;
    }
  }
}
.goodsUrl {
  width: 1px;
  height: 1px;
  position: absolute;
  top: 0;
  opacity: 0;
}
</style>
